import { collection, doc, serverTimestamp, writeBatch } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { logActivity } from "../../services/adminService";

const CHUNK = 200;

export async function commitPlan(items, period, onProgress) {
  const todo = items.filter((i) => i.action !== "skip");
  let created = 0;
  let updated = 0;
  let done = 0;

  for (let i = 0; i < todo.length; i += CHUNK) {
    const batch = writeBatch(db);
    const slice = todo.slice(i, i + CHUNK);

    slice.forEach((item) => {
      let memberId;
      let memberName;

      if (item.action === "create") {
        const ref = doc(collection(db, "members"));
        memberId = ref.id;
        memberName = item.memberName;
        batch.set(ref, {
          ...item.data,
          source: "excel-import",
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        });
        created += 1;
      } else {
        memberId = item.match.id;
        memberName = item.match.fullName;
        if (Object.keys(item.data).length) {
          batch.update(doc(db, "members", memberId), { ...item.data, updatedAt: serverTimestamp() });
        }
        updated += 1;
      }

      if (item.payment) {
        batch.set(
          doc(db, "payments", `${memberId}_${period}`),
          {
            memberId,
            memberName,
            period: String(period),
            ...item.payment,
            updatedAt: serverTimestamp(),
          },
          { merge: true }
        );
      }
    });

    await batch.commit();
    done += slice.length;
    if (onProgress) onProgress(done, todo.length);
  }

  await logActivity(
    "member",
    `Excel import: ${created} added, ${updated} updated (${items.length - todo.length} skipped)`
  );
  return { created, updated, skipped: items.length - todo.length };
}
